import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './sms.magic.css.js';
import script from './sms.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"sign-up-form",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit()}}},[_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","data-v-test-id":"step3-sms-text","content":_vm.$t('sign-up-step-three.introduction', { length: _vm.smsCodeLengthConfig })}}),_vm._v(" "),_c('magic-ui-form-field',{attrs:{"has-error":_vm.invalidCode,"message":_vm.$t('sign-up-step-three.error'),"placeholder":_vm.$t('sign-up-step-two.sms-verification-text')}},[_c('magic-ui-input',{ref:"code",attrs:{"type":"tel","value":(_vm.$v.code.$model)},on:{"beforeinput":_vm.preventNonDigits,"input":function($event){return _vm.$set(_vm.$v.code, "$model", $event.detail[0])}}})],1),_vm._v(" "),_c('div',{staticClass:"action"},[_c('magic-ui-button',{attrs:{"wide":"","variant":"primary","data-v-test-id":"step3-sms-submit-button","type":"submit","disabled":_vm.$v.$invalid,"loading":_vm.isLoading},domProps:{"innerHTML":_vm._s(_vm.$t('sign-up-step-three.button'))},on:{"click":function($event){return _vm.onSubmit()}}}),_vm._v(" "),_c('div',{staticClass:"resend-section"},[_c('magic-ui-button',{attrs:{"wide":"","hollow":"","variant":"primary","data-v-test-id":"step3-sms-resend-button","disabled":_vm.isResendDisabled},domProps:{"innerHTML":_vm._s(_vm.$t('sign-up-step-three.resend-button'))},on:{"click":function($event){$event.preventDefault();return _vm.resendCode()}}}),_vm._v(" "),(_vm.isResendDisabled)?_c('span',{staticClass:"cooldown-text"},[_vm._v("\n                "+_vm._s(_vm.$t('sign-up-step-three.resend-cooldown', { seconds: _vm.resendCooldownSeconds }))+"\n            ")]):_vm._e()],1)],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3206129f_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-3206129f";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
